import { useViewOnly } from '@/contexts/InteractionParadigm.context';
import { COLORS } from '@/styles/tokens/colors';

/** Returns neutral presentation colors or standard app text colors. */
export function useEstateValueMetricsColors() {
  const isViewOnly = useViewOnly();

  if (isViewOnly) {
    return {
      titleColor: COLORS.NEUTRAL_GRAY[900],
      valueColor: COLORS.NEUTRAL_GRAY[900],
      subtitleColor: COLORS.NEUTRAL_GRAY[500],
      dividerColor: COLORS.NEUTRAL_GRAY[200],
    };
  }

  return {
    titleColor: COLORS.TEXT.PRIMARY,
    valueColor: COLORS.TEXT.PRIMARY,
    subtitleColor: COLORS.TEXT.SECONDARY,
    dividerColor: COLORS.GRAY[200],
  };
}
